// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3x0uu","footer":"styles_footer__1ruN5","passCodeTooltip":"styles_passCodeTooltip__14I0S"};